import {styled} from '@linaria/react';
import React, {forwardRef} from 'react';
import {LoadingSpinner} from './LoadingSpinner';

interface LoadingPageSpinnerProps {
  className?: string;
  'data-testid'?: string;
}

export const LoadingPageSpinner = forwardRef<
  HTMLDivElement,
  LoadingPageSpinnerProps
>(function LoadingPageSpinner({className, 'data-testid': testId}, ref) {
  return (
    <Wrapper ref={ref} className={className} data-testid={testId}>
      <LoadingSpinner />
    </Wrapper>
  );
});

const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 75vh;
`;
